<!--
 * @Descripttion: 
 * @Version: 1.0.0
 * @Author: Li Yong
 * @Date: 2022-03-24 11:29:59
 * @LastEditors: 吴作杰 15727841808@163.com
 * @LastEditTime: 2023-09-01 09:41:09
-->
<template>
	<el-form :model="formData" label-width="130px" ref="form" :rules="rules" hide-required-asterisk>
		<el-form-item label="指定商品类目" prop="categories">
			<category-select
				v-model="formData['categories']"
				placeholder="请选择招商类目"
				addAll
				:multiple="true"
				:platformId="platformId"
				:backAllValues="true"
				style="width: 400px"
				@change="val => change('categories', val.join(','))"
			></category-select>
		</el-form-item>
	</el-form>
</template>
<script>
import { PLATFORM_DY } from '@/utils/dataMap';
import CategorySelect from '@/components/common/categorySelect';
import mixin from '../../mixin';
import { mapGetters } from 'vuex';
export default {
	name: 'CategoryForm',
	mixins: [mixin],
	data() {
		return {
			formData: {
				categories: [0],
			},
			platformId: +PLATFORM_DY.value,
			rules: {
				categories: [{ required: true, message: '指定招商类目不可为空' }],
			},
		};
	},
	computed: {
		...mapGetters(['dyCategoryList']),
	},
	methods: {
		validate() {
			return new Promise((resolve, reject) => {
				this.$refs.form.validate(valid => {
					if (valid) {
						const _form = { ...this.formData };
						const [first] = _form.categories;
						_form.categories = (first === 0 ? this.dyCategoryList.map(item => item.value) : _form.categories).join(',');
						resolve(_form);
					} else {
						reject(valid);
						return false;
					}
				});
			});
		},
		resetForm() {
			this.$refs.form.resetFields();
		},
		isFormModified() {
			return this.isModified;
		},
	},
	components: {
		CategorySelect,
	},
};
</script>
